module.exports = __webpack_public_path__ + "static/media/totally-turtles.59771f8f.png";